import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { GroupUser } from "../_types/group-user";

@Injectable({
    providedIn: 'root',
})
export class GroupUsersService extends Service<GroupUser> {
    public override type = 'groupUsers';
    public override url = 'auth/groupUsers';
}
